import { render, staticRenderFns } from "./courseoutlines.vue?vue&type=template&id=61ca0c2a&scoped=true&"
import script from "./courseoutlines.vue?vue&type=script&lang=js&"
export * from "./courseoutlines.vue?vue&type=script&lang=js&"
import style0 from "./courseoutlines.vue?vue&type=style&index=0&id=61ca0c2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ca0c2a",
  null
  
)

export default component.exports